// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"540131f7","458":"5733ccad","760":"c7e3d403","882":"da886864"}[chunkId] + ".chunk.js";
};